<script>

export default {
  name: "ManageProductInvoice",
  inject: ['clearance_0'],
  data() {
    return {
      invoices: [],
      providers: [],
      search: ''

    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredInvoice() {
      if (!this.search) {
        return this.invoices;
      }
      return this.invoices.filter(invoice =>
          invoice.code.includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    async getInvoice() {
      try {
        let result = await this.$api.get("/auth/invoices")
        if (result.status.toString() === "200") {
          this.invoices = result.data
          if (this.invoices === null) {
            this.invoices = ''
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getProviders() {
      try {
        let res = await this.$api.get("/auth/providers");
        if (res.status.toString() === "200") {
          this.providers = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async showInvoice(id) {
      this.$router.push({name: 'ShowInvoice', params: {id: id}})
    },
    getProviderById(id) {
      return this.providers.find(provider => provider.id === id) || {}
    },
    inputLimiterSearch() {
      this.search = this.search.replace(/[^a-z0-9 ñáéíóúü,.~\-"']/gi, '').trimStart();
    },
  },
  created() {
    this.getInvoice()
    this.getProviders()
  }

}
</script>

<template>
  <div id="section-0" class="container">

    <div class="userSearch">
      <h1>Facturas</h1>

      <div :class="sidebarData.includes('ad-prov-invoice-reg') ? 'subOpt' : 'subOptCenter'">
        <div>
          <input type="text" v-model="search" v-on:input="inputLimiterSearch" placeholder="Buscar por código ...">
        </div>
        <div>
          <button role="link" @click="$router.push('/scene/register_invoice')"
                  v-if="(sidebarData.includes('ad-prov-invoice-reg'))"
                  :disabled="!(sidebarData.includes('ad-prov-invoice-reg'))">Registrar nueva factura
          </button>
        </div>
      </div>


      <div class="table-container mt-4" v-if="invoices.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Fecha</th>
            <th>Código</th>
            <th>Proveedor</th>
            <th>Monto</th>
            <th>Opciones</th>


          </tr>

          </thead>
          <tbody>

          <tr v-for="(invoice, index) in filteredInvoice" :key="invoice.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ invoice.invoiceDate.substring(0, 10) }}</td>
            <td>{{ invoice.code }}</td>
            <td>{{ getProviderById(invoice.provider).name }}</td>
            <td>{{ invoice.netCost }}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="showInvoice(invoice.id)" role="link">Ver</button>
            </td>
          </tr>

          </tbody>

        </table>
      </div>
      <div v-else>
        <p class="bordered-p">No hay facturas disponibles.</p>
      </div>


    </div>
  </div>


</template>


<style>
.subOpt {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.subOptCenter {
  display: flex;
  justify-content: center;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

</style>